<template>
  <v-row>
    <v-col cols="12">
      <v-card class="px-0">
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">
            Documentos de soporte
            <piriod-beta-label element="Chip" feature="SupportingDocuments" />
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-query-builder class="mr-1" :query-map="filters" model="supporting-document" />
              <v-btn class="mr-1" outlined color="secondary" @click="dialogRequest=true"><v-icon left small>mdi-email</v-icon>Nueva solicitud</v-btn>
              <v-btn outlined color="secondary" @click="dialogCreate=true"><v-icon left small>mdi-plus-box</v-icon>Importar</v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <kanban-board ref="board" :query="$route.query" @upload-request="onUploadRequest" @view-pdf="onViewPdf" />
      </v-card>
    </v-col>

    <supporting-document-create-dialog v-model="dialogCreate" :submission-request="currentRequest" @created="refreshBoard" />
    <submission-request-create-dialog v-model="dialogRequest" @created="refreshBoard" />
    <pdf-viewer-dialog v-model="dialogPdf" :document-item="currentDocument" />
  </v-row>
</template>
<script>
import { supportingDocumentsFilters } from '@/collections/queryBuilderFilters'

import KanbanBoard from '@/components/supporting-documents/KanbanBoard'
import MetricKpi from '@/components/reports/MetricKpi'
import PdfViewerDialog from '@/components/supporting-documents/PdfViewerDialog'
import PiriodBetaLabel from '@/components/ux/PiriodBetaLabel'
import SubmissionRequestCreateDialog from '@/components/supporting-documents/SubmissionRequestCreateDialog'
import SupportingDocumentCreateDialog from '@/components/supporting-documents/SupportingDocumentCreateDialog'
import VQueryBuilder from '@/components/VQueryBuilder/VQueryBuilder'

export default {
  components: {
    KanbanBoard,
    MetricKpi,
    PdfViewerDialog,
    PiriodBetaLabel,
    SubmissionRequestCreateDialog,
    SupportingDocumentCreateDialog,
    VQueryBuilder
  },
  data: () => ({
    currentDocument: null,
    currentRequest: null,
    dialogCreate: false,
    dialogPdf: false,
    dialogRequest: false,
    filters: supportingDocumentsFilters
  }),
  created () {
    if (this.$route.query.dialog === 'import') {
      this.dialogCreate = true
    }
  },
  watch: {
    $route () {
      if (this.$route.query.dialog === 'import') {
        this.dialogCreate = true
      }
    },
    dialogCreate (open) {
      if (!open) this.currentRequest = null
    },
    dialogPdf (open) {
      if (!open) this.currentDocument = null
    }
  },
  methods: {
    refreshBoard () {
      if (this.$refs.board) {
        this.$refs.board.loadBoard()
      }
    },
    onUploadRequest (item) {
      this.currentRequest = item
      this.dialogCreate = true
    },
    onViewPdf (item) {
      this.currentDocument = item
      this.dialogPdf = true
    }
  }
}
</script>
